import { catalog, plural, quote } from '@nolens/i18n';

/** Página «Conta» e eliminação da conta. */
export const accountText = catalog(
  {
    title: 'Account',
    signedInAs: 'Signed in as',
    plansTitle: 'Your plans',
    plansHint: 'The plan of your personal space and of each team you belong to.',
    seePlan: 'See plan',
    deleteTitle: 'Delete account',
    deleteHint:
      'Deletes your account, your personal space with its guides, and the teams where you are the only member. This can’t be undone.',
    deleteButton: 'Delete account…',
    confirmTitle: 'Delete your account?',
    goes: 'What will be deleted',
    goesPersonal: (guides: number) =>
      `Your personal space and its ${guides} ${plural('en', guides, { one: 'guide', other: 'guides' })}.`,
    goesTeam: (name: string) => `The team ${quote('en', name)} (you are its only member).`,
    stays: 'What stays',
    staysTeam: (name: string) =>
      `The team ${quote('en', name)} and its guides, including those you created. Another member becomes the owner if you are the only one.`,
    extensionNote: 'The extension stops working until it’s connected to another account.',
    typeEmail: (email: string) => `To confirm, type ${email}`,
    cancel: 'Cancel',
    confirm: 'Delete my account',
  },
  {
    'pt-PT': {
      title: 'Conta',
      signedInAs: 'Sessão iniciada como',
      plansTitle: 'Os seus planos',
      plansHint: 'O plano do seu espaço pessoal e o de cada equipa a que pertence.',
      seePlan: 'Ver plano',
      deleteTitle: 'Apagar a conta',
      deleteHint:
        'Apaga a sua conta, o seu espaço pessoal com os guias e as equipas em que é o único membro. Não é possível desfazer.',
      deleteButton: 'Apagar a conta…',
      confirmTitle: 'Apagar a sua conta?',
      goes: 'O que é apagado',
      goesPersonal: (guides) =>
        `O seu espaço pessoal e ${plural('pt-PT', guides, { one: 'o', other: 'os' })} ${guides} ${plural('pt-PT', guides, { one: 'guia', other: 'guias' })}.`,
      goesTeam: (name) => `A equipa ${quote('pt-PT', name)} (é o único membro).`,
      stays: 'O que fica',
      staysTeam: (name) =>
        `A equipa ${quote('pt-PT', name)} e os guias dela, incluindo os que criou. Se for o único dono, outro membro passa a sê-lo.`,
      extensionNote: 'A extensão deixa de funcionar até ser ligada a outra conta.',
      typeEmail: (email) => `Para confirmar, escreva ${email}`,
      cancel: 'Cancelar',
      confirm: 'Apagar a minha conta',
    },
  },
);
